import { AddParkingComponent } from "./add-parking/add-parking.component";
import { EditParkingComponent } from "./edit-parking/edit-parking.component";
import { ViewParkingComponent } from "./view-parking/view-parking.component";

export const ParkingRouting: any = [
    { path: '', redirectTo: 'view-parking', pathMatch: 'full' },
    { path: 'add-parking', component: AddParkingComponent},
    { path: 'view-parking', component: ViewParkingComponent},
    { path: 'edit-parking/:id', component: EditParkingComponent},
];

export const ParkingRoutingBreadcrumbs = [
    { name: 'Edit', path: '/edit-parking' },
    { name: 'Add', path: '/add-parking' },

];